import axios from "axios";
import { GURL } from "./global";

export const GetRolesList = () => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Authentication/v1/Roles`;
  return axios.get(url);
};
